module.exports = __webpack_public_path__ + "img/TagAZ.27335e8f.png";